import { CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useScrollAndFocus } from '@/components/ux/hooks/use-scroll-and-focus';
import { cn } from '@/lib/utils';
import type { Reply as DealReply } from '@/models/registry';

import { useDeId } from '@/components/ml/de-id';
import { useEffect, useRef, useState } from 'react';
import CommentReplyHeader from './comment-reply-header';
import ReplyMenu from './reply-menu';
import { useGetTextFromContent } from './thread-de-id-ed';
import EditReplyTiptap from './tip-tap-editor/edit-reply-tiptap';

const ReplyDeIdEd = ({
  reply,
  dealId,
}: {
  reply: DealReply;
  dealId: string;
}) => {
  const { content } = reply;

  const { shouldShowFocus, focusRef } = useScrollAndFocus({
    uiType: 'reply',
    id: reply.id,
  });

  const replyHoverRef = useRef<HTMLDivElement>(null);

  const [isEditing, setIsEditing] = useState(false);

  const deIdMutation = useDeId({});
  const text = useGetTextFromContent(content);

  useEffect(() => {
    if (text) {
      deIdMutation.mutate(text);
    }
  }, [text]);

  return (
    <CardHeader
      className={cn('border-b p-4', {
        'border-primary border': shouldShowFocus,
      })}
      ref={(el) => {
        focusRef.current = el;
        replyHoverRef.current = el;
      }}
    >
      <CardTitle className="flex flex-row justify-between p-0 pt-0 pb-0">
        <CommentReplyHeader
          commentOrReply={reply}
          isEditingComment={isEditing}
        />
        <ReplyMenu
          reply={reply}
          dealId={dealId}
          hoverRef={focusRef}
          setIsEditingReply={setIsEditing}
        />
      </CardTitle>
      {isEditing ? (
        <EditReplyTiptap
          dealId={dealId}
          reply={reply}
          setIsEditingReply={setIsEditing}
          className="pl-6"
        />
      ) : (
        <CardDescription className="pl-6 whitespace-pre-wrap text-uneditable">
          {/* <MessageTipTap content={content} /> */}
          <div>{deIdMutation.data}</div>
        </CardDescription>
      )}
    </CardHeader>
  );
};

export default ReplyDeIdEd;
